// export const API_ENDPOINT = window.location.hostname.indexOf('192.') === 0
//   ? `http://api.nabil.test.${window.location.hostname}.xip.io/lazystate`
//   : window.location.hostname === 'localhost'
//   ? 'http://api.nabil.test/lazystate'
//   : 'https://api.nabil.folderstudio.com/lazystate'
// export const API_ENDPOINT = '/api'
export const API_ENDPOINT = 'https://api.nabil.com/lazystate'